import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(5),
    position: 'relative',

    textAlign: 'center',
    marginTop: theme.spacing(1),
  },
}));
